import { ApiClientError } from '../api/client.js';

export function mapError(error: unknown): string {
  if (error instanceof ApiClientError) {
    if (error.status === 401) {
      return 'Your session has expired. Sign in again.';
    }
    if (error.status === 403) {
      return 'You do not have permission for this action in the selected league.';
    }
    if (error.status === 404) {
      return 'Requested resource was not found.';
    }
    if (error.status === 409) {
      return `${error.message} Refresh data and retry.`;
    }
    if (error.status === 410) {
      return error.message;
    }
    if (error.status === 429) {
      return 'Too many requests. Please wait and retry.';
    }
    return error.message;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return 'Unexpected error';
}
